import React from 'react';
import { observer } from 'mobx-react';
import { PatientSalesOrderListTemplate } from 'themes/application/patient/pages';
import { setCurrentView } from 'core/utils';
import { PatientSalesOrderListViewStore } from 'application/patient/stores';

@setCurrentView((rootStore) => new PatientSalesOrderListViewStore(rootStore), 'listViewStore')
@observer
class PatientSalesOrderList extends React.Component {
    render() {
        return <PatientSalesOrderListTemplate {...this.props} />
    }
}

export default PatientSalesOrderList;